module.exports = __webpack_public_path__ + "img/team3.c06ff87d.png";